module.exports = __webpack_public_path__ + "img/config.5a60773a.svg";